import {ConfigProvider, DatePicker, Modal, Typography} from "antd";
import locale from "antd/lib/locale/ru_RU";
import SelectField from "./SelectForm";

import React from "react";
import {ExportReactCSV} from "../AnaliticsMain";

const { RangePicker } = DatePicker;
const {Title} = Typography;




const ModalForm = (props) => {
    const rpchange = (e) => {
        props.rpChange(e)

    }
    const changeObj = (id) => {
        props.buttonOnClick(id)
        props.onChangeSel(id)
    }

    let empty = props.data.length <= 0

    return (
        <Modal
            title={<Title level={5}>{props.title}</Title>}
            centered
            open={props.visible}
            onOk={() => props.cancel()}
            onCancel={() => props.cancel()}
            okText={props.okText}
            cancelText={props.cancelText}
        >
            {props.rangepicker &&
            <ConfigProvider locale={locale}>
                <RangePicker onCalendarChange={val => rpchange(val)}  />
            </ConfigProvider>
            }

            {props.selectVisible && <SelectField
                options={props.options}
                onChange={changeObj}
                placeholder={props.placeholderSel}
            />}
            <ExportReactCSV load={props.loading} data={props.data} empty={empty} headers={props.headers} separator={","} fileName={props.filename} />
        </Modal>
    )
}

export default ModalForm